import Box from "@mui/material/Box";
import styles from "./CrudLayout.module.scss";
import { Button } from "antd";
import { Modal } from "../../components/modal";
import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";

export const CrudLayout = ({
  title,
  children,
  formTitle,
  form,
  hasNewButton,
  onModalClosed,
  itemToEdit,
  cleanItemToEdit,
  modalHeight,
  rightTitle,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [formWithDefaultValue, setFormWithDefaultValue] = useState();
  const [newClick, setNewClick] = useState(false);
  const [item, setItem] = useState(null);

  useEffect(() => {
    if (itemToEdit) {
      setItem(itemToEdit);
      setNewClick(false);
      setFormWithDefaultValue(
        React.cloneElement(form, { defaultValues: itemToEdit }, null)
      );
      setModalOpen(true);
    }
  }, [itemToEdit, form]);

  const handleOpenModal = () => {
    setNewClick(true);
    setModalOpen(true);
  };

  const handleOnClose = () => {
    setModalOpen(false);
    setItem(null);
    cleanItemToEdit();
    onModalClosed && onModalClosed();
  };

  return (
    <>
      <Box>
        <div
          className={rightTitle ? styles.layoutHeader2 : styles.layoutHeader}
        >
          <h2>{title}</h2>
          {hasNewButton ? (
            <div className={styles.topEndComponent}>
              <Button
                type={"primary"}
                style={{ background: "#149925", color: "white", borderRadius: '4px', fontSize: '16px', fontWeight: 500, boxShadow: "1px 1px 5px 1px rgba(165, 165, 165, 0.82)" }}
                onClick={handleOpenModal}
                icon={<PlusOutlined style={{ fontSize: '18px', }} />}
                iconPosition={"end"}

              >
                Novo
              </Button>
            </div>
          ) : (
            <></>
          )}
        </div>

        <div style={{ paddingTop: "20px", height: '100%', width: "100%" }}>
          {children}
        </div>
      </Box>

      {hasNewButton ? (
        <Modal
          height={modalHeight ?? 600}
          open={modalOpen}
          onClose={handleOnClose}
          title={item ? "Editar Informações" : formTitle}
          children={item && !newClick ? formWithDefaultValue : form}
        />
      ) : (
        <></>
      )}
    </>
  );
};
